import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=2ed62400&scoped=true&"
import script from "./GroupHeader.vue?vue&type=script&lang=ts&"
export * from "./GroupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GroupHeader.vue?vue&type=style&index=0&id=2ed62400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed62400",
  null
  
)

export default component.exports